<template>
  <div v-if="award || share || surveyPoint">
    <el-carousel
      arrow="never"
      direction="vertical"
      indicator-position="none"
      :interval="2000"
      :autoplay="true"
      height="32px"
      @change="onChangeIndex"
      class="px-2"
    >
      <template v-if="!hideRewardPrompt">
        <template v-if="award">
          <el-carousel-item :key="1">
            <div class="phone-award-count">
              <span>前</span>
              <strong>
                <span class="text-medium text-black text-opacity-80">
                  {{ quantityAward }}
                </span>
              </strong>
              <span>名提交</span>
              <template v-if="needAuditFlagAward">并审核通过</template>
              <span>的答题人，可获得</span>
              <strong>
                <span class="text-medium text-red text-opacity-80">
                  {{ $bus.convertAwardAmountText(award) }}
                </span>
              </strong>
              <span>现金红包</span>
            </div>
          </el-carousel-item>
        </template>
        <template v-else-if="hadAward">
          <el-carousel-item :key="2">
            <div class="phone-award-count">问卷红包已被领完</div>
          </el-carousel-item>
        </template>
      </template>
      <template v-if="!hideShareRewardPrompt">
        <template v-if="share">
          <el-carousel-item :key="3">
            <div class="phone-share-count">
              <span>前</span>
              <strong
                ><span class="text-medium text-black text-opacity-80">
                  {{ quantityShare }}
                </span></strong
              >
              <span>名完成 的分享人，可获得</span>
              <strong>
                <span class="text-medium text-red text-opacity-80">
                  {{ $bus.convertAwardAmountText(share) }}
                </span>
              </strong>
              <span>现金红包</span>
            </div>
          </el-carousel-item>
        </template>
        <template v-else-if="hadShare">
          <el-carousel-item :key="4">
            <div class="phone-award-count">分享奖励已被领完</div>
          </el-carousel-item>
        </template>
      </template>
      <template v-if="!hideRewardPrompt && !hideShareRewardPrompt && (award || hadAward) && (share || hadShare)">
        <template v-if="award">
          <el-carousel-item :key="5">
            <div class="phone-award-count">
              <span>前</span>
              <strong>
                <span class="text-medium text-black text-opacity-80">
                  {{ quantityAward }}
                </span>
              </strong>
              <span>名提交</span>
              <template v-if="needAuditFlagAward">并审核通过</template>
              <span>的答题人，可获得</span>
              <strong>
                <span class="text-medium text-red text-opacity-80">
                  {{ $bus.convertAwardAmountText(award) }}
                </span>
              </strong>
              <span>现金红包</span>
            </div>
          </el-carousel-item>
        </template>
        <template v-else-if="hadAward">
          <el-carousel-item :key="6">
            <div class="phone-award-count">问卷红包已被领完</div>
          </el-carousel-item>
        </template>
        <template v-if="share">
          <el-carousel-item :key="7">
            <div class="phone-share-count">
              <span>前</span>
              <strong
                ><span class="text-medium text-black text-opacity-80">
                  {{ quantityShare }}
                </span></strong
              >
              <span>名完成 的分享人，可获得</span>
              <strong>
                <span class="text-medium text-red text-opacity-80">
                  {{ $bus.convertAwardAmountText(share) }}
                </span>
              </strong>
              <span>现金红包</span>
            </div>
          </el-carousel-item>
        </template>
        <template v-else-if="hadShare">
          <el-carousel-item :key="8">
            <div class="phone-award-count">分享奖励已被领完</div>
          </el-carousel-item>
        </template>
      </template>
      <template v-if="surveyPoint">
        <el-carousel-item key="surveyPoint">
          <div class="phone-award-count">
            <span>前</span>
            <strong>
              <span class="text-medium text-black text-opacity-80">
                {{ surveyPoint.limit }}
              </span>
            </strong>
            <span>名提交</span>
            <template v-if="needAuditFlagAward">并审核通过</template>
            <span>的答题人，可获得</span>
            <strong>
              <span class="text-medium text-red text-opacity-80">
                {{ surveyPoint.point }}
              </span>
            </strong>
            <span>积分</span>
          </div>
        </el-carousel-item>
      </template>
    </el-carousel>
  </div>
</template>

<script>
import { busGetters } from 'dygc'

export default {
  name: 'AwardNotice',
  computed: {
    needAuditFlagAward() {
      return this.$bus.enableNetManualAudit
    },
    hideRewardPrompt() {
      return this.survey.hideRewardPrompt !== 0
    },
    hideShareRewardPrompt() {
      return this.survey.hideShareRewardPrompt !== 0
    },
    amountShare({ share }) {
      return share && share.amount
    },
    quantityShare({ share }) {
      return share && share.quantity
    },
    quantityAward({ award }) {
      return award && award.quantity
    },
    amountAward({ award }) {
      return award && award.amount
    },
    swipe() {
      return (this.hadAward && !this.hideRewardPrompt) || (this.hadShare && !this.hideShareRewardPrompt)
    },
    ...busGetters(['hadAward', 'hadShare', 'award', 'share', 'survey', 'surveyPoint'])
  },
  methods: {
    onChangeIndex(index) {
      // console.log(index)
    }
  }
}
</script>
